import React, { useState } from 'react';
import ButtonComponent from '../../library/components/button.component';
import EmailIcon from '../../library/icons/email-icon';
import { HIERARCHY } from '../../library/constants/constants';
import ShieldBellIcon from '../../library/icons/shield-bell-icon';

const MagicLinkRenewComponent: React.FC<{ handleButtonClick: () => void }> = ({ handleButtonClick }) => {
    const [isSending, setIsSending] = useState<boolean>(false);

    const handleClick = () => {
        setIsSending(true);
        handleButtonClick();
    };

    return (
        <div className="linkcontent">
            <div className="img">
                <ShieldBellIcon />
            </div>
            <h2>It's time to renew this share link</h2>
            <p>We do this to improve security. It won't be long...</p>

            <ButtonComponent
                icon={<EmailIcon />}
                type={HIERARCHY.PRIMARY}
                text="Renew my share link"
                onClick={handleClick}
                isSaving={isSending}
            />
        </div>
    );
};

export default MagicLinkRenewComponent;
